module.exports = __webpack_public_path__ + "static/media/towel-picto.f9df2816.svg";